import { ProductType } from '@common/enums';
import { convertProductsToProductDetailsList } from '@common/utils';

export const convertEdgesToProductDetails = convertProductsToProductDetailsList(ProductType.EDGE);
